import api from "../../../api";

const API_URL = "/crm/expense-categories";

export async function getExpenseCategories() {
  const res = await api.get(API_URL);
  return res.data;
}

export async function getExpenseCategory(id) {
  const res = await api.get(`${API_URL}/${id}`);
  return res.data;
}

export async function createExpenseCategory(data) {
  const res = await api.post(API_URL, data);
  return res.data;
}

export async function updateExpenseCategory(id, data) {
  const res = await api.put(`${API_URL}/${id}`, data);
  return res.data;
}

export async function deleteExpenseCategory(id) {
  return api.delete(`${API_URL}/${id}`);
}

